import script from "./ElCardSectionWithIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElCardSectionWithIcon.vue?vue&type=script&lang=ts&setup=true"

import "./ElCardSectionWithIcon.vue?vue&type=style&index=0&id=04295f9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04295f9a"]])

export default __exports__